export interface IDictionary {
  id: number;
  parentId: number;
  type: string;
  displayName: string;
  value: string;
}


export interface GroupedDeviceModel {
  parent: IDictionary;
  children: IDictionary[];
  selectedChildren: Set<number>;
  selected: boolean;
}